<script setup lang="ts">
const user = useUser()
const { colors } = useTheme()
</script>

<template>
  <div v-if="user" h-full w-full bg-white overflow-auto>
    <PromptListSaved
      :user="user"
      :limit-height="false"
      lazy-load
      :list-style="{ paddingBottom: '64px' }"
    />
  </div>

  <Text v-else :color="colors.bluishDarker">
    Something went wrong.
  </Text>
</template>
